<section>
  
    <div class="container-fluid px-5 mt-4">
     
      <div class="col-12 d-flex justify-content-between pb-4">
        <div>
          <h4 class="text-white h2 my-4 ">Editar hito</h4>
        </div>
        <br>
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="badge rounded-pill btn btn-outline-light "
            [routerLink]="['/pdg/project/list/view/', idProject]"
          >
            <i
              class="fa-solid fa-right-from-bracket m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6">Volver</span>
          </button>
    
         
    
      
    
        </div>
      </div>
  
      <div class="backgroundTable card">
        <div class="card-header">
          <h4 class="text-white p-2">Editar hito proyecto</h4>
        </div>
  
        <div class="componente-importantes componente-importantes-from-popup">
          <form
            action=""
            method="post"
            (submit)="formSubmit()"
            [formGroup]="createMilestoneForm"
          >
            <div class="col">
                  <div class="form-group  px-3 pb-3">
                      
                      <label for="text-white" class="text-white d-flex justify-content-start mb-2">Etapa del Proyecto</label>
                      <select
                          class="form-control custom-outline-input"
                          id="project_stages_id"
                          formControlName="project_stages_id"
                          aria-label="Default select"
                      >
                          <option [selected]="true" value="0">Seleccionar Etapa</option>
                          <option
                          *ngFor="let listDependence of detailsMilestone.listDependence"
                          [ngValue]="listDependence.id"
                          >
                          {{ listDependence.name }}
                          </option>
                      </select>
                  </div>
  
                  <div class="form-group px-3 pb-3">
                      <label for="formControlInput" class="text-white d-flex justify-content-start mb-2">Titulo</label>
                      <input
                      type="text"
                      placeholder="Ingrese información"
                      id="title"
                      formControlName="title"
                      class="form-control custom-outline-input"
                      />
                  </div>
  
                  <div class="form-group px-3 pb-3">
                  
                      <label for="formControlInput" class="text-white d-flex justify-content-start mb-2"
                      >Fecha Inicio</label
                      >
                      <input
                      type="date"
                      class="form-control custom-outline-input date"
                      id="start_date"
                      formControlName="start_date"
                      />
  
                  </div>
  
                  <div class="form-group px-3 pb-3">
                  
                      <label for="formControlInput" class="text-white d-flex justify-content-start mb-2"
                      >Fecha Fin</label
                      >
                      <input
                      type="date"
                      class="form-control custom-outline-input date"
                      id="end_date"
                      formControlName="end_date"
                      />
  
                  </div>
  
                  <div class="form-group px-3 pb-3">
                  
                      <label for="formControlInput" class="text-white d-flex justify-content-start mb-2">Estado</label>
                      <select
                      class="custom-outline-input form-select mt-3"
                      id="state"
                      formControlName="state"
                      aria-label="Default select"
                      >
                      <option value="0">Seleccionar Estado</option>
                      <option
                          *ngFor="let stado of detailsMilestone.listStado"
                          [ngValue]="stado.id"
                      >
                          {{ stado.name }}
                      </option>
                      </select>
  
                  </div>
                  <div class="form-group px-3 pb-3">
                  
                      <label for="formControlInput" class="text-white d-flex justify-content-start mb-2"
                      >Detalles</label
                      >
                      <textarea
                      class="form-control custom-outline-input date"
                      placeholder="Dejar detalles aqui..."
                      formControlName="description"
                      id="description"
                      style="height: 100px !important"
                      ></textarea>
                  </div>
  
                  <div class="col-12 d-flex justify-content-end p-3 pb-4">
                  <button class="mx-2 btn btn-outline-light">
                      <i class="fa fa-floppy-disk" aria-hidden="true"></i> Guardar
                      datos
                  </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  